import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Edit, Delete, Visibility, Add } from "@mui/icons-material";
import brandService from '../service/brandService'; 


const BrandManager = () => {
  const [brands, setBrands] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [form, setForm] = useState({ brandId: "", name: "", description: "" });

  // Fetch all brands
  const fetchBrands = async () => {
    try {
      const res = await brandService.fetchBrand(); //axiosInstance.get("/brands"); // Adjust endpoint
      setBrands(res);
    } catch (err) {
      console.error("Error fetching brands", err);
    }
  };

  useEffect(() => {
    fetchBrands();
  }, []);

  // Open add form
  const handleAdd = () => {
    setForm({ brandId: "", name: "", description: "" });
    setOpenForm(true);
  };

  // Open edit form
  const handleEdit = (brand) => {
    setForm(brand);
    setOpenForm(true);
  };

  // Save brand (create or update)
  const handleSave = async () => {
    try {
      if (form.brandId) {
        await brandService.updateBrand(form.brandId, form); //axiosInstance.put(`/brands/${form.brandId}`, form);
      } else {
        await brandService.saveBrand(form); //axiosInstance.post("/brands", form);
      }
      setOpenForm(false);
      fetchBrands();
    } catch (err) {
      console.error("Error saving brand", err);
    }
  };

  // Delete brand
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this brand?")) {
      try {
        await brandService.deleteBrand();// axiosInstance.delete(`/brands/${id}`);
        fetchBrands();
      } catch (err) {
        console.error("Error deleting brand", err);
      }
    }
  };

  // View details
  const handleView = (brand) => {
    setSelectedBrand(brand);
    setOpenView(true);
  };

  const columns = [
    { field: "brandId", headerName: "ID", width: 90 },
    { field: "name", headerName: "Name", flex: 1 },
    { field: "description", headerName: "Description", flex: 2 },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => (
        <>
          <Tooltip title="Edit">
            <IconButton onClick={() => handleEdit(params.row)}>
              <Edit color="primary" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton onClick={() => handleDelete(params.row.brandId)}>
              <Delete color="error" />
            </IconButton>
          </Tooltip>
          <Tooltip title="View">
            <IconButton onClick={() => handleView(params.row)}>
              <Visibility color="action" />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <div style={{ height: 500, width: "100%", padding: "20px" }}>
      <h2>Brand Management</h2>
      <Button
        variant="contained"
        startIcon={<Add />}
        onClick={handleAdd}
        style={{ marginBottom: 10 }}
      >
        Add Brand
      </Button>
      <DataGrid
        rows={brands}
        columns={columns}
        getRowId={(row) => row.brandId}
        pageSize={5}
        rowsPerPageOptions={[5, 10, 20]}
      />

      {/* Add/Edit Dialog */}
      <Dialog open={openForm} onClose={() => setOpenForm(false)}>
        <DialogTitle>{form.brandId ? "Edit Brand" : "Add Brand"}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Name"
            fullWidth
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Description"
            fullWidth
            multiline
            rows={3}
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenForm(false)}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Details Dialog */}
      <Dialog open={openView} onClose={() => setOpenView(false)}>
        <DialogTitle>Brand Details</DialogTitle>
        <DialogContent>
          {selectedBrand && (
            <div>
              <p>
                <strong>ID:</strong> {selectedBrand.brandId}
              </p>
              <p>
                <strong>Name:</strong> {selectedBrand.name}
              </p>
              <p>
                <strong>Description:</strong> {selectedBrand.description}
              </p>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenView(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BrandManager;
